module.exports = __webpack_public_path__ + "img/frame1.0936d4bf.svg";